import { useEffect, useRef, useState } from "react";

const COMMENTS = [
  {
    handle: "@chinou_vaj",
    image: "/images/social/chinou_vaj.jpg",
    text: "Took me 2 seconds to sign up. If this does what I think it does, game over for my excuses. 💀",
  },
  {
    handle: "@rahul.thenix",
    image: "/images/social/rahul.thenix.jpg",
    text: "Finally, something that doesn't let you make excuses. Dropped my email immediately.",
  },
  {
    handle: "@joens_7",
    image: "/images/social/joens_7.jpg",
    text: "Bro, I need this. I've restarted my fitness journey like 6 times this year. 😭",
  },
  {
    handle: "@andreaxbuono",
    image: "/images/social/andreaxbuono.jpg",
    text: "Sent this to my gym partner, and we both dropped our emails immediately. We need this bad. 😭",
  },
  {
    handle: "@chenar_a7",
    image: "/images/social/chenar_a7.jpg",
    text: "My problem was never motivation; it's staying consistent past week 2. This might actually fix that.",
  },
  {
    handle: "@feder_p95",
    image: "/images/social/feder_p95.jpg",
    text: "I've been 'starting Monday' for 6 months straight. Just signed up. No more Mondays.",
  },
];

const INSTAGRAM_URL = "https://www.instagram.com/edith.wins";

function InstagramIcon({ size = 12 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4.5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
    </svg>
  );
}

export default function SocialProof() {
  const sectionRef = useRef(null);

  return (
    <section
      ref={sectionRef}
      id="social-proof"
      className="nm-section-dark reveal-section"
      data-reveal
      data-testid="social-proof-section"
    >
      <div className="nm-container py-20 md:py-24">

        {/* ── Header ── */}
        <div className="mb-12 md:mb-16">
          <span className="nm-eyebrow inline-block text-black/50">Social Proof</span>

          <h2 className="mt-4 text-[clamp(1.8rem,4.5vw,3.2rem)] text-black leading-[0.95] max-w-2xl">
            Trusted by a Community of 32,000 Ambitious People.
          </h2>

          <div className="flex items-center gap-2 mt-5">
            <InstagramIcon size={16} />
            <span className="text-sm font-medium text-black/70">
              Follow us on Instagram →{" "}
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold text-black hover:underline transition-colors"
              >
                @edith.wins
              </a>
            </span>
          </div>
        </div>

        {/* ── Comment cards grid ── */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {COMMENTS.map((c, i) => (
            <div
              key={i}
              className="bg-[#fafafa] border border-black/25 rounded-xl p-5 flex flex-col gap-3"
              data-testid={`comment-${i}`}
            >
              {/* Avatar + handle */}
              <div className="flex items-center gap-2.5">
                {c.image ? (
                  <img src={c.image} alt={c.handle} className="w-7 h-7 rounded-full object-cover flex-shrink-0" />
                ) : (
                  <div className="w-7 h-7 rounded-full bg-black/10 flex items-center justify-center flex-shrink-0">
                    <span className="text-[10px] font-black text-black/50 uppercase">
                      {c.handle[1].toUpperCase()}
                    </span>
                  </div>
                )}
                <span className="text-xs font-semibold text-black/50">{c.handle}</span>
              </div>

              {/* Quote */}
              <p className="text-sm text-black font-medium leading-relaxed flex-1">
                "{c.text}"
              </p>

              {/* Instagram label */}
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-black/60 hover:text-black transition-colors pt-1 no-underline"
              >
                <InstagramIcon size={10} />
                <span className="text-[10px] font-bold uppercase tracking-[0.15em]">
                  via Instagram
                </span>
              </a>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
